import script from "./registry-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./registry-edit-form.vue?vue&type=script&setup=true&lang=js"

import "./registry-edit-form.vue?vue&type=style&index=0&id=6197a55c&lang=css"

const __exports__ = script;

export default __exports__